import { Card, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { errorCatch, GET, useUserContext } from 'fennec-ui';
import AvatarEditor from '../../components/AvatarEditor';
import { isAnyFederationAdministrator, isMyEvent } from '../../../common/Tool';
import PageLayout from '../../components/PageLayout';

export default function CommonEventsByIDAvatar(props) {
    let { id } = useParams();
    const { auth } = props;
    const user = useUserContext();

    const [event, setEvent] = useState(undefined);
    useEffect(() => {
        GET(auth, `/api/meropriyatiya/list/com?detail=model&w-id=${id}`,
            ({ data }) => {
                if (data && data.length) {
                    setEvent(data[0]);
                }
            }, errorCatch);
    }, [])
    const admin = (event && user) ? (isMyEvent(event, user, false)|| isAnyFederationAdministrator(user)) : false;
    return (
        <PageLayout hideBreadcrumbs={true}>
            <Row gutter={[5, 5]}>
                <Col span={24} style={{ paddingLeft: "1px", paddingRight: "2px" }}>
                    <Card size="small">
                        <div style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                            <div style={{ textAlign: "left" }}>
                                {event &&
                                    <AvatarEditor event={event} admin={admin}/>
                                }
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
}
